import React, { useState, useEffect } from 'react';
import { dersLabel } from '../lib/dersler';
import { LatexText, LatexParagraphs, GorselDiagram, SIK_HARFLERI } from './SoruKarti';
import { trTarih, trZaman, tlMetni } from '../lib/satis';
import { pufListesi } from '../lib/pufNoktalari';

// ============================================================================
// SATIŞ ARŞİVİ MODALI (2026-09-14) — tek sorunun satış geçmişi + SATILAN SÜRÜM.
// GET /api/satis/:public_no/arsiv → { gecmis (iptaller dahil, yeni→eski),
// aktif, icerik_snapshot, degisti, degisen_alanlar }.
// Satış münhasır ve iptal SİLMEZ (kullanıcı kararı): geçmişte iptal edilen
// kayıtlar "iptal edildi" izi ile durur. `icerik_snapshot` satış anındaki içerik;
// soru sonradan değiştiyse (bilinçli "yine de düzenle" onayıyla) amber uyarı
// hangi alanların değiştiğini söyler. Metin/şık/çözüm SoruKarti'nin render
// bileşenleriyle (LatexText / LatexParagraphs / GorselDiagram) basılır.
// ============================================================================

const ALAN_ETIKET = {
  soru_metni_latex: 'soru metni',
  sik_a: 'A şıkkı', sik_b: 'B şıkkı', sik_c: 'C şıkkı', sik_d: 'D şıkkı', sik_e: 'E şıkkı',
  dogru_cevap: 'doğru cevap',
  cozum_adimlari_latex: 'çözüm adımları',
  cozum_son_cevap: 'çözümün son cevabı',
  pratik_cozum: 'pratik çözüm',
  puf_noktalari: 'püf noktaları',
  diyagram_tikz: 'TikZ figür',
  gorsel_url: 'görsel',
  ders: 'ders', konu: 'konu', alt_konu: 'alt konu', kazanim_kodu: 'kazanım kodu',
  durum: 'durum', kaynak_detay: 'kaynak detayı', zorluk_puan: 'puan',
};
export const alanEtiketi = (a) => ALAN_ETIKET[a] || String(a).replace(/_/g, ' ');

const metin = (v) => (v == null ? '' : String(v));

function SatilanSurum({ snap }) {
  const gorsel = snap.gorsel_url || snap.gorsel_base64;
  const puflar = pufListesi(snap.puf_noktalari);
  const siklar = SIK_HARFLERI.filter((h) => metin(snap[`sik_${h.toLowerCase()}`]).trim());
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-1.5 text-[11px]">
        {snap.ders && <span className="px-2 py-0.5 rounded bg-blue-50 text-blue-700 font-semibold">{dersLabel(snap.ders)}</span>}
        {snap.konu && <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-700">{snap.konu}</span>}
        {snap.kazanim_kodu && <span className="px-2 py-0.5 rounded bg-blue-50 text-blue-700">{snap.kazanim_kodu}</span>}
        {snap.durum && <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-500">satış anındaki durum: {snap.durum}</span>}
      </div>

      {metin(snap.soru_metni_latex).trim() && (
        <LatexParagraphs className="text-[15px] text-gray-800">{metin(snap.soru_metni_latex)}</LatexParagraphs>
      )}
      {gorsel && <GorselDiagram gorsel={gorsel} />}
      {snap.diyagram_tikz && (
        <div className="text-[11px] text-gray-500 italic border border-dashed border-gray-300 rounded-lg px-3 py-2">
          TikZ figür (panelde görüntülenir)
        </div>
      )}

      {siklar.length > 0 && (
        <div className="flex flex-col gap-1.5">
          {siklar.map((h) => {
            const dogru = snap.dogru_cevap === h;
            return (
              <div key={h} className={`px-3 py-1.5 rounded-lg text-[14px] break-words ${dogru ? 'bg-green-50 border-2 border-green-500' : 'bg-gray-50 border border-gray-100'}`}>
                <span className="font-bold mr-2 text-gray-600">({h})</span>
                <LatexText>{metin(snap[`sik_${h.toLowerCase()}`])}</LatexText>
                {dogru && <span className="text-green-600 font-bold text-xs ml-2">✓ DOĞRU</span>}
              </div>
            );
          })}
        </div>
      )}
      {snap.dogru_cevap && siklar.length === 0 && (
        <div className="text-xs text-gray-600">Doğru cevap: <strong>{snap.dogru_cevap}</strong></div>
      )}

      {(metin(snap.cozum_adimlari_latex).trim() || metin(snap.cozum_son_cevap).trim()) && (
        <div className="bg-blue-50/60 border border-blue-100 rounded-lg p-3">
          <div className="text-xs font-semibold text-blue-800 mb-1.5">Çözüm</div>
          {metin(snap.cozum_adimlari_latex).trim() && (
            <LatexParagraphs className="text-[14px] text-gray-800">{metin(snap.cozum_adimlari_latex)}</LatexParagraphs>
          )}
          {metin(snap.cozum_son_cevap).trim() && (
            <div className="mt-2 text-[13px]">
              <span className="font-semibold">Son cevap:</span> <LatexText>{metin(snap.cozum_son_cevap)}</LatexText>
            </div>
          )}
        </div>
      )}

      {(metin(snap.pratik_cozum).trim() || puflar.length > 0) && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          {metin(snap.pratik_cozum).trim() && (
            <>
              <div className="text-xs font-semibold text-amber-800 mb-1.5">⚡ Pratik çözüm</div>
              <LatexParagraphs className="text-[14px] text-gray-800">{metin(snap.pratik_cozum)}</LatexParagraphs>
            </>
          )}
          {puflar.length > 0 && (
            <div className="mt-2 space-y-1.5">
              <div className="text-[11px] font-semibold text-amber-900 uppercase tracking-wide">💡 Püf noktaları</div>
              {puflar.map((p, i) => (
                <div key={i} className="bg-white rounded p-2 text-[13px] border border-amber-100">
                  {p.baslik && <div className="font-semibold text-amber-900"><LatexText>{metin(p.baslik)}</LatexText></div>}
                  {p.aciklama && <div className="text-gray-700"><LatexText>{metin(p.aciklama)}</LatexText></div>}
                  {p.formul && <div className="text-gray-700"><LatexText>{metin(p.formul)}</LatexText></div>}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function GecmisSatiri({ k }) {
  const iptal = !!k.iptal_zamani;
  return (
    <tr className={`border-t border-gray-100 align-top ${iptal ? 'bg-gray-50 text-gray-500' : ''}`}>
      <td className="px-2 py-1.5 whitespace-nowrap">{trTarih(k.satis_tarihi) || trTarih(k.isaretlenme_zamani) || '—'}</td>
      <td className="px-2 py-1.5 font-medium">{k.yayinevi || '—'}</td>
      <td className="px-2 py-1.5 text-right whitespace-nowrap">
        {k.birim_fiyat != null
          ? tlMetni(k.birim_fiyat)
          : <span className="px-1 rounded bg-amber-100 text-amber-800">teslim · fiyat bekliyor</span>}
      </td>
      <td className="px-2 py-1.5">
        {iptal ? (
          <div>
            <span className="px-1.5 py-0.5 rounded bg-red-100 text-red-800 font-semibold">İptal edildi</span>
            <div className="mt-0.5 text-[11px]">
              {trZaman(k.iptal_zamani)}{k.iptal_eden_email ? ` · ${k.iptal_eden_email}` : ''}
            </div>
            {k.iptal_nedeni && <div className="text-[11px] italic">“{k.iptal_nedeni}”</div>}
          </div>
        ) : (
          <span className="px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-800 font-semibold">Aktif</span>
        )}
        {(k.isaretleyen_email || k.deneme_etiketi || k.not_metni) && (
          <div className="mt-0.5 text-[11px] text-gray-400">
            {[k.isaretleyen_email && `işaretleyen ${k.isaretleyen_email}`, k.deneme_etiketi, k.not_metni].filter(Boolean).join(' · ')}
          </div>
        )}
      </td>
    </tr>
  );
}

export default function SatisArsivModal({ apiUrl, authFetch, publicNo, onKapat }) {
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    let iptal = false;
    setYukleniyor(true); setHata(''); setVeri(null);
    authFetch(`${apiUrl}/api/satis/${encodeURIComponent(publicNo)}/arsiv`)
      .then((r) => r.json())
      .then((d) => {
        if (iptal) return;
        if (!d || !d.basarili) throw new Error((d && d.hata) || 'Arşiv alınamadı');
        setVeri(d);
      })
      .catch((e) => { if (!iptal) setHata(e.message || 'Arşiv alınamadı'); })
      .finally(() => { if (!iptal) setYukleniyor(false); });
    return () => { iptal = true; };
  }, [apiUrl, authFetch, publicNo]);

  useEffect(() => {
    const tus = (e) => { if (e.key === 'Escape' && onKapat) onKapat(); };
    window.addEventListener('keydown', tus);
    return () => window.removeEventListener('keydown', tus);
  }, [onKapat]);

  const gecmis = (veri && Array.isArray(veri.gecmis)) ? veri.gecmis : [];
  const aktif = veri && veri.aktif;
  const snap = veri && veri.icerik_snapshot;

  return (
    <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center bg-black/40 p-4 overflow-y-auto" onClick={onKapat}>
      <div onClick={(e) => e.stopPropagation()} role="dialog" aria-label={`#${publicNo} satış arşivi`} data-arsiv-modal
        className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[92vh] overflow-y-auto p-4 space-y-4 font-serif">
        <div className="flex items-center justify-between gap-2 font-sans">
          <div className="flex items-center gap-2">
            <span className="bg-gray-800 text-white px-2 py-0.5 rounded-md text-sm font-bold">#{publicNo}</span>
            <span className="font-bold text-gray-800">Satış arşivi</span>
          </div>
          <div className="flex items-center gap-3">
            <a href={`?public_no=${encodeURIComponent(publicNo)}`} target="_blank" rel="noopener noreferrer"
              className="text-xs text-blue-600 hover:underline font-semibold">↗ Panelde aç</a>
            <button type="button" onClick={onKapat} className="text-gray-400 hover:text-gray-700" aria-label="Kapat">✕</button>
          </div>
        </div>

        {yukleniyor && <div className="p-6 text-center text-gray-400 text-sm font-sans">Yükleniyor…</div>}
        {hata && <div className="p-3 bg-red-50 border border-red-300 rounded-lg text-red-700 text-sm font-sans">{hata}</div>}

        {veri && (
          <div className="space-y-4 font-sans">
            {aktif ? (
              <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-900">
                <strong>Aktif:</strong> {aktif.yayinevi || '—'} · {trTarih(aktif.satis_tarihi) || '—'} ·{' '}
                {aktif.birim_fiyat != null ? tlMetni(aktif.birim_fiyat) : 'fiyat bekliyor (PDF teslimi)'}
              </div>
            ) : (
              <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-600">
                Bu sorunun aktif satışı yok{gecmis.length > 0 ? ' — geçmişteki kayıtlar iptal edilmiş.' : '.'}
              </div>
            )}

            {veri.degisti === true && (
              <div data-degisti className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900">
                ⚠ <strong>Satıştan sonra değişti:</strong>{' '}
                {(veri.degisen_alanlar || []).map(alanEtiketi).join(', ') || 'alan bilgisi yok'}
              </div>
            )}
            {veri.degisti === false && (
              <div className="rounded-lg border border-emerald-200 bg-white px-3 py-2 text-xs text-emerald-800">
                ✓ Güncel içerik satılan sürümle aynı.
              </div>
            )}

            <div>
              <div className="text-[11px] font-bold uppercase text-gray-500 mb-1">Satış geçmişi ({gecmis.length})</div>
              {gecmis.length === 0 ? (
                <div className="text-xs text-gray-400 italic">Kayıt yok.</div>
              ) : (
                <div className="overflow-x-auto border border-gray-100 rounded-lg">
                  <table className="w-full text-xs">
                    <thead className="bg-gray-50 text-gray-500">
                      <tr>
                        <th className="text-left px-2 py-1.5 font-semibold">Tarih</th>
                        <th className="text-left px-2 py-1.5 font-semibold">Yayınevi</th>
                        <th className="text-right px-2 py-1.5 font-semibold">Fiyat</th>
                        <th className="text-left px-2 py-1.5 font-semibold">Durum</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gecmis.map((k, i) => <GecmisSatiri key={k.id ?? i} k={k} />)}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div>
              <div className="text-[11px] font-bold uppercase text-gray-500 mb-1">Satılan sürüm</div>
              {snap ? (
                <div className="border border-gray-200 rounded-lg p-3 font-serif"><SatilanSurum snap={snap} /></div>
              ) : (
                <div className="text-xs text-gray-400 italic">
                  Bu satış için içerik anlık görüntüsü yok (anlık görüntü kaydından önceki satış).
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
